import { Env } from './env'

export const isLocal = process.env.REACT_APP_ENV === 'local'

export const isAws = ['development', 'production'].includes(process.env.REACT_APP_ENV || '')

export type AwsCredentials = {
  accessKeyId: string
  secretAccessKey: string
}

export function getAwsCredentials(): AwsCredentials | undefined {
  if (isLocal) {
    return {
      accessKeyId: process.env[Env.REACT_APP_AWS_ACCESS_KEY_ID] || '',
      secretAccessKey: process.env[Env.REACT_APP_AWS_SECRET_ACCESS_KEY] || '',
    }
  }
  return undefined
}

export function getAwsRegion(): string {
  return process.env[Env.REACT_APP_AWS_REGION] || 'us-east-1'
}
